import SideNav from 'CoreComponents/sideNav/';

// Setup the side nav only if it's there
if (document.querySelector('.side-nav')) {
  new SideNav();
}



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/sideNav.js